import api from './utilPartner';

const controller = 'IntegracaoProposta';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  ListarPorParceiro: function () {
    return api.Axios.GetParams(`${url}/ListarPorParceiro`);
  }
});